/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityDataleaksResultEvidence
 */
export interface ControlEntityDataleaksResultEvidence {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    target_url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    user_hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    user_os?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    user_browser?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    infected_machine_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    infected_path?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    infected_time?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksResultEvidence
     */
    publish_date?: string;
}

/**
 * Check if a given object implements the ControlEntityDataleaksResultEvidence interface.
 */
export function instanceOfControlEntityDataleaksResultEvidence(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityDataleaksResultEvidenceFromJSON(json: any): ControlEntityDataleaksResultEvidence {
    return ControlEntityDataleaksResultEvidenceFromJSONTyped(json, false);
}

export function ControlEntityDataleaksResultEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityDataleaksResultEvidence {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'target_url': !exists(json, 'target_url') ? undefined : json['target_url'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'user_hostname': !exists(json, 'user_hostname') ? undefined : json['user_hostname'],
        'user_os': !exists(json, 'user_os') ? undefined : json['user_os'],
        'user_browser': !exists(json, 'user_browser') ? undefined : json['user_browser'],
        'infected_machine_id': !exists(json, 'infected_machine_id') ? undefined : json['infected_machine_id'],
        'infected_path': !exists(json, 'infected_path') ? undefined : json['infected_path'],
        'infected_time': !exists(json, 'infected_time') ? undefined : json['infected_time'],
        'publish_date': !exists(json, 'publish_date') ? undefined : json['publish_date'],
    };
}

export function ControlEntityDataleaksResultEvidenceToJSON(value?: ControlEntityDataleaksResultEvidence | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_url': value.target_url,
        'ip_addresses': value.ip_addresses,
        'user_hostname': value.user_hostname,
        'user_os': value.user_os,
        'user_browser': value.user_browser,
        'infected_machine_id': value.infected_machine_id,
        'infected_path': value.infected_path,
        'infected_time': value.infected_time,
        'publish_date': value.publish_date,
    };
}

